<template>
  <div v-if="showBadges" class="admin-card-badges">
    <badge v-if="statusLabel" icon="assignment" :label="statusLabel" />
    <badge v-if="card.needsReview" icon="assignment" label="Needs Review" />
  </div>
</template>

<script>
import Badge from './Badge';

export default {
  components: {
    Badge,
  },

  props: {
    card: Object,
  },

  computed: {
    showBadges() {
      return !this.card.collectionCardId && this.card.cardId && this.card.hidden;
    },

    statusLabel() {
      const status = this.card.status;

      if (status === 'progress') {
        return 'In Progress';
      } else if (status === 'review') {
        return 'In Review';
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.admin-card-badges {
  display: flex;
  flex-wrap: wrap;
  margin-top: $gp;

  > *:not(:last-child) {
    margin-right: $gp * .5;
  }

  > * {
    margin-bottom: $gp * .5;
  }
}
</style>
